var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip",class:_vm.classNames,attrs:{"tabindex":"0"}},[_c('IconQuestion',{staticClass:"tooltip__icon"}),(_vm.$slots.default)?_c('p',{staticClass:"tooltip__content"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }